<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">{{
        item.id ? 'Edit Category' : 'Create Category'
      }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <category-form :data="data"></category-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-btn v-if="loadFailed" text color="primary" @click="loadCategory">
        Retry loading category
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn :disabled="loading" color="blue darken-1" text @click="_close"
        >Cancel</v-btn
      >
      <v-btn :disabled="!canSave" color="blue darken-1" text @click="save">{{
        item.id ? 'Update' : 'Create'
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FormErrors from '../../../components/FormErrors'
import CategoryForm from './CategoryForm'
import { axios } from '../../../utils'

const emptyCategory = () => ({
  name: '',
  group_id: null,
  group: null,
  slug: ''
})

export default {
  name: 'CategoryDialog',
  props: ['close', 'categories', 'item'],
  components: { FormErrors, CategoryForm },
  data() {
    return {
      data: emptyCategory(),
      loading: false,
      loadFailed: false,
      errors: []
    }
  },
  computed: {
    canSave() {
      return (
        !this.loading &&
        !this.loadFailed &&
        !!this.data.name.trim() &&
        !!this.data.group_id
      )
    }
  },
  mounted() {
    if (this.item.id) this.loadCategory()
  },
  methods: {
    async loadCategory() {
      this.loading = true
      this.loadFailed = false
      this.errors = []
      try {
        const response = await axios.get('api/admin/categories/' + this.item.id)
        const category = response.data
        this.data = {
          name: category.name || '',
          group_id:
            category.group_id == null ? null : Number(category.group_id),
          group: category.group || null,
          slug: category.slug || ''
        }
      } catch (error) {
        this.loadFailed = true
        this.errors = [['Unable to load this category. Please try again.']]
      } finally {
        this.loading = false
      }
    },
    async save() {
      if (!this.canSave) return
      this.loading = true
      this.errors = []
      const payload = {
        name: this.data.name.trim(),
        group_id: this.data.group_id
      }
      try {
        if (this.item.id) {
          await axios.put(`api/admin/categories/${this.item.id}`, payload)
        } else {
          await axios.post('api/admin/categories/create', payload)
        }
        this._close()
      } catch (error) {
        const response = error.response
        this.errors =
          response && response.status === 422 && response.data.errors
            ? Object.values(response.data.errors)
            : [['Unable to save this category. Please try again.']]
      } finally {
        this.loading = false
      }
    },
    _close() {
      this.data = emptyCategory()
      this.errors = []
      this.close()
    }
  }
}
</script>
